var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.00003V1.21003C8.5 0.760031 7.96 0.540031 7.65 0.860031L4.85 3.65003C4.65 3.85003 4.65 4.16003 4.85 4.36003L7.64 7.15003C7.96 7.46003 8.5 7.24003 8.5 6.79003V5.00003C11.81 5.00003 14.5 7.69003 14.5 11C14.5 11.79 14.35 12.56 14.06 13.25C13.91 13.61 14.02 14.02 14.29 14.29C14.8 14.8 15.66 14.62 15.93 13.95C16.3 13.04 16.5 12.04 16.5 11C16.5 6.58003 12.92 3.00003 8.5 3.00003ZM8.5 17C5.19 17 2.5 14.31 2.5 11C2.5 10.21 2.65 9.44003 2.94 8.75003C3.09 8.39003 2.98 7.98003 2.71 7.71003C2.2 7.20003 1.34 7.38003 1.07 8.05003C0.7 8.96003 0.5 9.96003 0.5 11C0.5 15.42 4.08 19 8.5 19V20.79C8.5 21.24 9.04 21.46 9.35 21.14L12.14 18.35C12.34 18.15 12.34 17.84 12.14 17.64L9.35 14.85C9.04 14.54 8.5 14.76 8.5 15.21V17Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncWhite);
export default __webpack_public_path__ + "static/media/sync-white.346693a1911eacff8f99d043a93a215d.svg";
export { ForwardRef as ReactComponent };